import { render, staticRenderFns } from "./TypeManagement.vue?vue&type=template&id=15f5e7ac&scoped=true&"
import script from "./TypeManagement.vue?vue&type=script&lang=js&"
export * from "./TypeManagement.vue?vue&type=script&lang=js&"
import style0 from "./TypeManagement.vue?vue&type=style&index=0&id=15f5e7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f5e7ac",
  null
  
)

export default component.exports